import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LocalStorageService {

  private storage: Storage;

  constructor() {
    this.storage = window.localStorage;
  }

  set(key: string, value: any): boolean {
    if (this.storage) {
      this.storage.setItem(key, JSON.stringify(value));
      return true;
    }
    return false;
  }

  setWithExpiry(key: string, value: any, ttl: number): boolean {
    if (this.storage) {
      const now = new Date();
      const item = {
        value: value,
        expiry: now.getTime() + ttl, 
      };
      try {
        this.storage.setItem(key, JSON.stringify(item));
        return true;
      } catch (e) {
        console.error('Erro ao salvar no local storage', e);
      }
    }
    return false;
  }

  get(key: string): any {
    if (this.storage) {
      return JSON.parse(this.storage.getItem(key)!);
    }
    return null;
  }

  getWithExpiry(key: string): any | null {
    const itemStr = localStorage.getItem(key);
    if (!itemStr) {
      return null;
    }

    const item = JSON.parse(itemStr);
    const now = new Date();

    if (now.getTime() > item.expiry) {
      localStorage.removeItem(key);
      return null;
    }

    return item.value;
  }

  remove(key: string): boolean {
    if (this.storage) {
      this.storage.removeItem(key);
      return true;
    }
    return false;
  }

  /**
   * Remove todas as chaves cujo nome começa com o prefixo informado.
   * Usado para limpar caches escopados (ex.: 'scppg_', 'idProgramaPdaiVagas')
   * ao trocar de usuário (logout / simular acesso).
   */
  removeByPrefix(prefix: string): boolean {
    if (!this.storage) {
      return false;
    }
    const keys: string[] = [];
    for (let i = 0; i < this.storage.length; i++) {
      const key = this.storage.key(i);
      if (key && key.indexOf(prefix) === 0) {
        keys.push(key);
      }
    }
    keys.forEach(key => this.storage.removeItem(key));
    return true;
  }

  clear(): boolean {
    if (this.storage) {
      this.storage.clear();
      return true;
    }
    return false;
  }

}
